export default "__VITE_ASSET__cdf85a5e__"